export default "__VITE_ASSET__BmZuzBVN__"